module.exports = __webpack_public_path__ + "3490fa9be320f0264015edff46762ad8.jpg";